import ExamsStragglesRepository from '@/domain/repositories/ExamStragglesRepository';
import ExamstragglesDataStore from '../datastores/ExamstragglesDataStore';
import ExamsStragglesDataStoreFactory from '../factories/ExamStragglesDataStoreFactory';

export default class ExamsStragglesDataRepository
  implements ExamsStragglesRepository
{
  getLateCourses(career: string, periodId: string) {
    const examstragglesDataStore: ExamstragglesDataStore =
      ExamsStragglesDataStoreFactory.create();
    return examstragglesDataStore.getLateCourses(career, periodId);
  }

  registerLateCourses(request: any) {
    const examstragglesDataStore: ExamstragglesDataStore =
      ExamsStragglesDataStoreFactory.create();
    return examstragglesDataStore.registerLateCourses(request);
  }

  activatePaymentLateCourses(requestId: number) {
    const lateCoursesDataStore: ExamstragglesDataStore =
      ExamsStragglesDataStoreFactory.create();
    return lateCoursesDataStore.activatePaymentLateCourses(requestId);
  }
}
